
import styled from 'styled-components';

const IconFontAwesome = styled.i(({ color, size}) => `
  color: ${color};
  font-size: ${size}rem;
`);

export default IconFontAwesome;
